import { FaChevronDownLightSvgIcon } from '../../../assets/icons/svgs';
import spacing, { isMobileScreen } from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';
import { modalCloseIconStyle } from '../utils';

const DrawerCloseTopLeftButton = ({ onClick }: { onClick?: () => void }) => {
  if (isMobileScreen) {
    return null;
  }

  return (
    <FaChevronDownLightSvgIcon
      onClick={onClick}
      className="onClickEffect"
      size={fontSize['2xl']}
      style={{
        ...modalCloseIconStyle,
        right: 'unset',
        border: 'none',
        left: spacing.medium,
        visibility: isMobileScreen ? 'hidden' : 'visible',
        animation: 'fadeInOnRender 2.5s',
        pointerEvents: 'none',
        background: 'transparent',
      }}
    />
  );
};

export default DrawerCloseTopLeftButton;
